﻿import ActivePage from "../activePage";

export default class DMSValuationMatrixPage extends ActivePage {

    constructor() {
        super();
    }

    initialize = (screen, id) => {
        this.editableGrids = [
            { name: "dmsValuationMatrixRateGrid", filter: { parentId: id }, afterSubmit: this.updateRecordStamps }
        ];

        this.tabsLoaded = [];
        this.tabChangeSetListener();
    }

    tabChangeSetListener = () => {
        const self = this;
        $('#dmsValuationMatrix-tab a').on('click',
            (e) => {
                e.preventDefault();
                const tab = e.target.id;
                if (this.tabsLoaded.indexOf(tab) === -1) {
                    this.tabsLoaded.push(tab);
                    this.loadTabContent(tab);
                }
            });        
    }

    loadTabContent(tab) {
        switch (tab) {

            case "":
                break;
        }
    }

    getParentTStamp = () => {
        const container = $(`#${this.detailContentContainer}`);
        const tStamp = container.find("input[name='tStamp']");
        return tStamp.val();
    }    

    matrixRateGrid_dataBound(e) {
        this.setGridReadOnlyRow(e);
        var grid = $(`#${e.sender.element[0].id}`).data("kendoGrid");
        const ratingSystem = $("#RatingSystem").val();  
        if (ratingSystem != "Numeric Range") {
            grid.hideColumn("WeightMax");
            grid.thead.find("[data-field='WeightMin']").html('Value');
        }
        if (ratingSystem == "") {
            grid.hideColumn("WeightMin");
        }          

        var items = e.sender.items();
        items.each(function (index) {
            var dataItem = grid.dataItem(this);
            if (dataItem.RateId == 0 || dataItem.CanEditWeight) {
                this.cells[2].className += "editable-cell";
                this.cells[3].className += "editable-cell";
            }
        })
    }

    showCopyScreen() {
        const popupContainer = $(".site-content .popup").last();
        const dialogContainer = popupContainer.find("#dmsValuationMatrixCopyDialog");
        let entryForm = dialogContainer.find("form")[0];
        dialogContainer.modal("show");
        const self = this;

        entryForm = $(entryForm);
        const afterSubmit = function (result) {
            const dataContainer = $('#' + self.mainDetailContainer).find(".cpiDataContainer");
            if (dataContainer.length > 0) {
                setTimeout(function () {
                    dataContainer.empty();
                    dataContainer.html(result);
                }, 1000);
            }
        };
        entryForm.cpiPopupEntryForm({ dialogContainer: dialogContainer, afterSubmit: afterSubmit });
    }
}
